export interface LoginProvider {
  type: string;
  backendURL: string,
  name: string,
  color: string,
  showLoginButton: boolean,
  id: string
}

/**
 * Current State of the application
 * 
 * Used to define the template of the primary app.component component
 * 
 */
export enum ApplicationStates {
  "LoggedIn",
  "LoggedOut",
  "PreLogout",
  "PendingEmailVerification",
  "Error"
}


export interface UISecurityProvider {
  canDeleteContacts(): boolean
}